

// const apiKey = "http://127.0.0.1:8000"
// const apiKeyHttp = "127.0.0.1:8000"
// // const apiKey="https://edu.taswog.com"
// export default apiKey
// export {apiKeyHttp}


// const apiKey = "http://127.0.0.1:8000"
const apiKeyHttp = "127.0.0.1"
const apiKey="https://edu.taswog.com"
export default apiKey
export {apiKeyHttp}

// //const apiKey = "http://127.0.0.1:8000"
//  const apiKey="https://edu.taswog.com"
//  const apiKeyHttp="https://edu.taswog.com"
//  export default apiKey
//  export {apiKeyHttp}
